import { Button, Checkbox, Modal } from '@teamsnap/teamsnap-ui';
import { reactiveFeedbackMessage } from 'core/apollo-cache';
import { countBy, currencyGivenPennies } from 'core/utils';
import {
  LoadingType,
  useOrderDetails,
  useOrderDetailsActions,
} from 'hooks/orderDetails';
import * as React from 'react';
import '../add-note-sidebar.scss';

type Props = {
  show: boolean;
  close: () => void;
  fees: { id: number; amount: number }[];
};

const CancelFeesModal = ({ show, close, fees }: Props) => {
  const [deleteRosterProfiles, setDeleteRosterProfiles] = React.useState(false);
  const { order, loading } = useOrderDetails();
  const { getOrder, cancelFees } = useOrderDetailsActions();

  const onClose = () => {
    setDeleteRosterProfiles(false);
    close();
  };

  const onSubmit = () => {
    cancelFees(
      order?.id,
      fees.map((x) => x.id),
      deleteRosterProfiles
    )
      .then(() => {
        close();
        setDeleteRosterProfiles(false);

        reactiveFeedbackMessage({
          message: 'Fee(s) are successfully canceled',
          autoclose: true,
          isError: false,
        });
        getOrder(order?.orderNumber);
      })
      .catch(() => {
        reactiveFeedbackMessage({
          message:
            'Oops! It looks like we ran into a problem canceling fees. Please try again or reach out to TeamSnap support for help.',
          autoclose: true,
          isError: true,
        });
      });
  };

  return (
    <Modal
      showClose
      allowOverlayClose
      show={show}
      closeFn={onClose}
      style={{ width: '651px', minWidth: 0 }}
      heading={`Cancel Fee${fees.length > 1 ? 's' : ''}`}
    >
      <p data-testid="cancel-fees-modal--no-refund-msg">
        Canceling the selected fee(s) does not refund any payments. Refunds must
        be manually applied.
      </p>
      <p data-testid="cancel-fees-modal--status-cancelled-msg">
        If canceling all fees and adjustments for the order the participant's
        status will be updated to “Canceled”.
      </p>
      <br />
      <p data-testid="cancel-fees-modal--are-you-sure-msg">
        Are you sure you want to cancel the selected fee(s)? This cannot be
        undone.{' '}
      </p>

      <div>
        <Checkbox
          isInline
          id="deleteRosterProfiles"
          name="deleteRosterProfiles"
          label="Delete roster profile(s) for the participant(s) selected"
          mods="u-spaceEndsLg"
          inputProps={{
            value: deleteRosterProfiles,
            onChange: () => setDeleteRosterProfiles(!deleteRosterProfiles),
          }}
        />
      </div>

      <Button
        mods="u-spaceRightSm"
        onClick={onClose}
        testId="cancel-fees-modal--cancel-button"
      >
        Cancel
      </Button>
      <Button
        testId="cancel-fees-modal--yes-button"
        mods="u-colorForeground u-bgNegative"
        isDisabled={loading[LoadingType.CancelFees]}
        onClick={onSubmit}
      >
        Yes, Cancel {currencyGivenPennies(countBy(fees, (x) => x.amount))}
      </Button>
    </Modal>
  );
};

export default CancelFeesModal;
